module.exports = __webpack_public_path__ + "img/AlteDIN1451Mittelschrift.c9f77d5a.svg";